<template>
    <div class="twitchMessages-list-container">
        <h2>Twitch Messages</h2>
        <ul v-if="messagesVisible">
            <li v-for="message in twitchMessage" :key="message.id">
                <p>{{ message.username }}: <strong>{{ message.message }}</strong></p>
            </li>
        </ul>
        <br>
        <br>
        <div v-if="showButton">
            <button class="btn-twitchMessages" @click="toggleMessagesVisibility">{{ messagesVisible ? 'Hide' : 'Show' }}
                List</button>
        </div>
    </div>
</template>
<script>
import { socket } from '@/socket';

export default {
    props: {
        showButton: {
            required: true
        },
    },
    methods: {
        toggleMessagesVisibility() {
            this.$store.dispatch("toggleMessagesVisibility")

        },
        getTwitchMessages() {
            if (this.user == null) return
            if (!this.listVisible) return
            this.$store.dispatch("getFollowers")
        },
    },
    computed: {
        token() {
            return this.$store.state.token
        },
        twitchMessage() {
            return this.$store.state.message
        },
        messagesVisible() {
            return this.$store.state.twitchMessagesVisible
        },
    },
    watch: {
        messagesVisible: {
            immediate: true,
            handler() {
                if (this.messagesVisible) {
                    this.getTwitchMessages()
                }
            }
        },
    },
    mounted() {
        this.$store.dispatch("getTwitchToken")
        this.$store.dispatch("getTwitchMessages")
        this.$store.dispatch("setTwitchMessagesListener")
        socket.on("twitchSettings-inserted", () => {
            this.$store.dispatch("fetchTwitchSettings")
        });
    },
    unmounted() {
        socket.off("twitchSettings-inserted")
    },
}
</script>
<style lang="scss" scoped>
@import "@/assets/_variables.scss";

.twitchMessages-list-container {
    background: $bubble-color;
    width: 100%;
    padding: 1rem;
    border-radius: 10px;
    position: relative;
}

ul {
    list-style-type: none;
    padding: 0;
    width: auto;
    margin-bottom: 2rem;
}

li {
    margin-top: 1rem;
    background: $bubble-two-color;
    width: auto;
    padding: 1rem;
    border-radius: 10px;
}

.btn-twitchMessages {
    border: none;
    padding: 0.5rem 1rem;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
    background: $bubble-two-color;
    color: $color-blue;
    position: absolute;
    bottom: 0;
    width: -webkit-fill-available;
    margin: 0 1rem 1rem 0;
}

.btn-twitchMessages:hover {
    color: $color-light_blue;
    background-color: $bubble-color;
}
</style>